import React from 'react';
import MessageModeration from './MessageModeration';
import { useChat } from '../modules/ChatPane';
import Linkify from 'react-linkify';

// Standard pubnub chat message
export default function Message({ message, channeltype, containerRef }) {
  const {
    channel,
    message: { user, text, type },
  } = message;

  const {
    context: { viewUser },
  } = useChat();
  // console.log(user);

  const viewProfile = () => {
    if (message.message.user.user_firstname === 'Anonymous') {
      return;
    }
    const user = new CustomUser();
    user.initialize(message.message.user);
    viewUser(user);
  };

  if (message.actions?.flag?.kicked) {
    return <></>;
  }

  if (type === 'update') {
    return (
      <div className={`message_wrapper message_child`}>
        <div className={`message_container message_update`}>
          <div className={`message_name`}>
            <div className={`name_inner truncate`}>{text}</div>
          </div>
          <div className={`message`}></div>
        </div>
      </div>
    );
  }
  let userName = user.user_firstname;
  if (CrowdHub_App.CONFIG.SHOW_USER_LASTNAME_IN_MESSAGE) {
    userName += ` ${user.user_lastname}`;
  }
  // we want to hide the dimension and tags when the user is anonymous
  if (message.message.user.user_firstname === 'Anonymous') {
    return (
      <div className={`message_wrapper message_child`}>
        <div className={`message_container`}>
          <div className={`message_name`}>
            <div className={`name_inner truncate`}>{userName}</div>
          </div>
          <div className={`message`}>
            <Linkify properties={{ target: '_blank' }}>{text}</Linkify>
          </div>
        </div>
        <MessageModeration message={message} room={channel} channeltype={channeltype} containerRef={containerRef} />
      </div>
    );
  }
  return (
    <div className={`message_wrapper message_child`}>
      <div className={`message_user message_child`} onClick={viewProfile}>
        <div
          className={`message_avatar cover`}
          style={{
            //@ts-ignore
            backgroundImage: `url('${App.INSTANCE.getImageSrc(user.avatar)}')`,
          }}
        />
      </div>
      <div className={`message_container`}>
        <div className={`message_name`}>
          <div className={`name_inner truncate`}>
            {userName} {user?.preferred_tags[0]?.tag_name} {user?.dimensions[0]?.value}
          </div>
        </div>
        <div className={`message`}>
          <Linkify
            componentDecorator={(decoratedHref, decoratedText, key) => (
              <a target="blank" href={decoratedHref} key={key}>
                {decoratedText}
              </a>
            )}
          >
            {text}
          </Linkify>
        </div>
      </div>
      <MessageModeration message={message} room={channel} channeltype={channeltype} containerRef={containerRef} />
    </div>
  );
}
